import { ResourceFieldDirectiveModule } from '@b2b/common/directives/resourceField/resourceField';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { ColumnDef, TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { ILogService, IScope, ITimeoutService } from 'angular';

export const ResourcesInstancesControllerModule = angular
  .module('acme.view.application.resources.instances.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.calendar',
    'acme.common.directive.relatedProgramTemplates',
    ResourceFieldDirectiveModule,
  ])
  .controller('ResourcesInstancesController', [
    '$scope',
    '$state',
    '$timeout',
    '$log',
    'ApiService',
    'HelpersService',
    'ValidateService',
    'CalendarService',
    function ResourcesInstancesController(
      $scope: IScope & { resourcesInstances: TODO; assignedResourcesGridOptions: TODO },
      $state: StateService,
      $timeout: ITimeoutService,
      $log: ILogService,
      ApiService: ApiService,
      HelpersService: TODO,
      ValidateService: TODO,
      CalendarService: CalendarService
    ) {
      $scope.resourcesInstances = {
        events: [],
        currentView: '',
        visibleStartDate: '',
        startTime: new Date(),
        endTime: new Date().setMonth(new Date().getMonth() + 1),

        init: function () {
          if ($state.params.hasOwnProperty('id')) {
            this.templateId = $state.params.id;
            this.getDetail(this.templateId);
          }

          $scope.$emit('Application::contentTitleChange', {
            title: 'View Resource',
            buttonLeft: {
              label: '< Back',
              action: function () {
                window.history.go(-1);
              },
            },
          });

          $scope.$on('calendar[resources-instance-calendar]::onViewRender', function (e, data) {
            const visibleStartDate = new Date(data.view.visStart).getTime();
            if (
              data.view.start &&
              data.view.end &&
              ($scope.resourcesInstances.currentView !== data.view.name ||
                $scope.resourcesInstances.visibleStartDate !== visibleStartDate) &&
              $scope.resourcesInstances.model.hasOwnProperty('ownerId')
            ) {
              console.log('calendar[resources-instance-calendar]::onViewRender', data);

              $scope.resourcesInstances.startTime = new Date(data.view.start);
              $scope.resourcesInstances.endTime = new Date(data.view.end);
              $scope.resourcesInstances.currentView = data.view.name;
              $scope.resourcesInstances.visibleStartDate = visibleStartDate;
              $scope.resourcesInstances.getAssigned($scope.resourcesInstances.model.ownerId);
            }
          });
        },

        templateId: -1,
        showErrors: false,
        isLoading: false,

        model: {},

        assignmentColumns: [],
        assignedResources: [],
        selectedAssignedResources: [],

        errors: [],

        hasModelFields: function () {
          return this.model.fields instanceof Array && this.model.fields.length > 0;
        },

        hasAssignedResources: function () {
          return this.assignedResources instanceof Array && this.assignedResources.length > 0;
        },

        getDetail: function (id) {
          ApiService.resource.instances.detail(id).then(this.success.getDetail, this.error.getDetail);
        },

        getAssigned: function (id) {
          const startTime = this.startTime;
          const endTime = this.endTime;

          ApiService.entity.schedules
            .owner({
              ownerId: id,
              startTime: CalendarService.toISO8601(startTime),
              endTime: CalendarService.toISO8601(endTime),
            })
            .then(this.success.getAssigned, this.error.getAssigned);
        },

        processResources: function (resources) {
          const processed: { id: TODO; name: TODO }[] = [];
          const cols = [
            {
              field: 'name',
              displayName: 'Name',
              cellTemplate:
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })">{{row.getProperty(col.field)}}</a></div>',
            },
          ] as ColumnDef[];

          for (let i = 0, ii = resources.length; i < ii; i++) {
            const row = {
              id: resources[i].ownerId,
              name: resources[i].name,
            };

            if (i === 0 && resources[i].resourceCategory === 'Personnel') {
              cols[0].cellTemplate =
                '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.users.detail({ id: {{ row.entity.id }} })">{{row.getProperty(col.field)}}</a></div>';
            }

            if (resources[i].fields instanceof Array) {
              for (let j = 0, jj = resources[i].fields.length; j < jj; j++) {
                row['id_' + resources[i].fields[j].fieldOrder] =
                  HelpersService.getFieldValue(resources[i].fields[j], true) || '-';
                if (i === 0) {
                  cols.push({
                    field: 'id_' + resources[i].fields[j].fieldOrder,
                    displayName: resources[i].fields[j].name,
                  });
                }
                console.log(
                  'ResourcesDetailController::processResources -> rowUser',
                  row['id_' + resources[i].fields[j].fieldOrder]
                );
              }
            }
            //console.log('ResourcesDetailController::processResources -> rowUser', row);

            processed.push(row);
          }

          $scope.resourcesInstances.assignmentColumns = cols;

          console.log('ResourcesDetailController::processResources', processed);
          return processed;
        },

        success: {
          getDetail: function (response, status, headers, config) {
            $scope.resourcesInstances.showErrors = false;
            $scope.resourcesInstances.model = response.data.payload;
            $scope.resourcesInstances.model.resourceCategory = response.data.payload.resourceCategory;
            $scope.resourcesInstances.getAssigned(response.data.payload.ownerId);
          },

          getAssigned: function (response) {
            if (response.data.payload.length > 0) {
              $scope.resourcesInstances.events.splice(0, $scope.resourcesInstances.events.length);

              for (let i = 0, ii = response.data.payload.length; i < ii; i++) {
                const start = new Date(response.data.payload[i].startDateTime);
                const end = new Date(response.data.payload[i].endDateTime);

                $scope.resourcesInstances.events.push({
                  id: response.data.payload[i].id,
                  title: response.data.payload[i].eventName,
                  start: response.data.payload[i].startDateTime,
                  end: response.data.payload[i].endDateTime,
                  allDay: (start.valueOf() - end.valueOf()) / (1000 * 60 * 60 * 24) >= 1,
                });
              }

              $scope.$broadcast('calendarCreateEvent::events');
            }
          },
        },

        error: {
          getTemplate: function (response, status, headers, config) {
            // TODO: Need to handle this
            $scope.resourcesInstances.showErrors = true;
            $scope.resourcesInstances.errors = [
              {
                message: 'There was a problem getting template',
              },
            ];
          },

          getAssigned: function (response) {},
        },
      };

      $scope.assignedResourcesGridOptions = {
        enableColumnResize: true,
        selectedItems: $scope.resourcesInstances.selectedAssignedResources,
        columnDefs: 'resourcesInstances.assignmentColumns',
        data: 'resourcesInstances.assignedResources',
      };

      $scope.resourcesInstances.init();
    },
  ]).name;
